<template>
  <div>
    <!--新手指南H5 -->
    <baseBreadcrumb :page="$t('message.beginnerSGuideH5')" :menu="$t('message.operationAndMaintenance')" />
    <div class="body">
      <div class="search">
        <div class="btn">
          <!-- 添加一类类目 -->
          <el-button type="success" @click="addACategory">
            {{ $t('message.addACategory') }}
          </el-button>
          <!-- 添加说明 -->
          <el-button type="success" @click="articleAdd">
            {{ $t('message.addDescription') }}
          </el-button>
        </div>
      </div>
      <!-- 列表 -->
      <div class="table">
        <div class="item" v-for="(item, index) in tableData" :key="index">
          <div class="head">
            <div class="sort items">
              icon
            </div>
            <!-- 排序 -->
            <div class="sort items">
              {{ $t('message.sort') }}
            </div>
            <!-- 类目名 -->
            <div class="categoryName  items">
              {{ $t('message.categoryName') }}
            </div>
            <!-- 上新提醒 -->
            <div class="operation items">
              {{ $t('message.newArrivalReminder') }}
            </div>
            <!-- 状态 -->
            <div class="operation items">
              {{ $t('message.status') }}
            </div>
            <!-- 操作 -->
            <div class="operation items">
              {{ $t('message.operation') }}
            </div>
          </div>
          <div class="content">
            <div class="sort items">
              <el-image style="width: 50px; height: 50px" :src="item.icon" :preview-src-list="[item.icon]"
                v-if="item.icon">
              </el-image>
            </div>
            <!-- 排序 -->
            <div class="sort items">
              {{ item.sort }}
            </div>
            <!-- 类目名 -->
            <div class="categoryName  items">
              {{ item.name }}
            </div>
            <!-- 上新提醒 -->
            <div class="operation items">
              <el-switch v-model="item.is_new" @change=" guideIsNewH5(item, 'category')">
              </el-switch>
            </div>
            <!-- 状态 -->
            <div class="operation items">
              {{ item.is_show == 1 ? '启用' : '禁用' }}
            </div>
            <!-- 操作 -->
            <div class="operation items">
              <i class="el-icon-edit-outline" @click="categoryEdit(item)"></i>
              <i class="el-icon-delete" @click="categoryDestroyH5(item.id)"></i>
            </div>
          </div>
          <ol v-if="item.guide_article_h5 != false">
            <!-- 排序 -->
            <li> icon</li>
            <!-- 标题 -->
            <li class="flex3"> {{ $t('message.title') }}</li>
            <!-- 答案 -->
            <li class="flex5"> {{ $t('message.content') }}</li>
            <!-- 排序 -->
            <li> {{ $t('message.sort') }}</li>
            <!-- 上新提醒 -->
            <li> {{ $t('message.newArrivalReminder') }}</li>
            <!-- 状态 -->
            <li> {{ $t('message.status') }}</li>
            <!-- 操作 -->
            <li class="flex15"> {{ $t('message.operation') }}</li>
          </ol>
          <ul v-for="(items, indexs) in item.guide_article_h5" :key="indexs">
            <li class="flex"> <el-image style="width: 50px; height: 50px" :src="items.icon"
                :preview-src-list="[items.icon]" v-if="items.icon">
              </el-image></li>
            <!-- 标题 -->
            <li class="flex3"> {{ items.title }}</li>
            <!-- 内容 -->
            <li class="flex5 flex">
              <el-button type="primary" @click="preview(items.content)">预览</el-button>
            </li>
            <!-- 排序 -->
            <li class="flex"> {{ items.sort }}</li>
            <!-- 上新提醒 -->
            <li class="flex"> <el-switch v-model="items.is_new" @change=" guideIsNewH5(items, 'article')">
              </el-switch></li>
            <!-- 状态 -->
            <li class="flex"> {{ items.is_show == 1 ? '启用' : '禁用' }}</li>
            <!-- 操作 -->
            <li class="flex15 flex">
              <i class="el-icon-edit-outline" @click="articleEdit(items)"></i>
              <i class="el-icon-delete" @click="articleDestroyH5(items.id)"></i>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 添加编辑类目 -->
    <categor :isAdd="isAdd" ref="categor" />
    <!-- 添加编辑题目 -->
    <Article :isAdd="isAdd" ref="Article" :tableData="tableData" />
    <!--  -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" width="1200px" center title="预览">
      <div v-html="content" class="preview ql-editor"></div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>

      </span>
    </el-dialog>
  </div>
</template>
<script>
import categor from './components/categor'
import Article from './components/article'
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  components: {
    categor,
    Article
  },
  data() {
    return {
      tableData: [],
      isAdd: true,
      content: '',
      dialogVisible: false
    };
  },
  created() {
    this.guideArticleListH5()
  },
  methods: {
    guideArticleListH5() {
      this.$api.siteConfiguration.guideArticleListH5({ keyword: '' }).then(res => {
        res.data.forEach(item => {
          item.is_new = item.is_new == 1 ? true : false
          item.guide_article_h5.forEach(items => {
            items.is_new = items.is_new == 1 ? true : false
          })
        })
        this.tableData = res.data
      })
    },
    // 新增类目
    addACategory() {
      this.isAdd = true
      this.$refs.categor.acceptData({
        name: '',
        sort: 0,
        show: false,
        icon: '',
      })
    },

    //修改类目
    categoryEdit(item) {
      this.isAdd = false
      let itemData = JSON.parse(JSON.stringify(item))
      itemData.show = itemData.is_show == 1 ? true : false
      this.$refs.categor.acceptData(itemData)
    },
    //删除类目
    categoryDestroyH5(id) {
      this.$confirm(
        // 是否确认删除
        this.$t("message.areYouSureToDelete"),
        // 提示
        this.$t("message.prompt"),
        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true
        }
      )
        .then(() => {
          this.$api.siteConfiguration.categoryDestroyH5({ id }).then(res => {
            this.$message.success(res.msg)
            this.guideArticleListH5()

          })
        })
        .catch(() => { });

    },
    //新增文章
    articleAdd() {
      this.isAdd = true
      this.$refs.Article.acceptData({
        category_id: '',
        title: '',
        sort: 0,
        content: '',
        icon: '',
        show: false,
      })
    },
    // 文章-修改
    articleEdit(item) {
      this.isAdd = false
      let itemData = JSON.parse(JSON.stringify(item))
      itemData.show = itemData.is_show == 1 ? true : false
      this.$refs.Article.acceptData(itemData)
    },
    //删除问题
    articleDestroyH5(id) {
      this.$confirm(
        // 是否确认删除
        this.$t("message.areYouSureToDelete"),
        // 提示
        this.$t("message.prompt"),
        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true
        }
      )
        .then(() => {
          this.$api.siteConfiguration.articleDestroyH5({ id }).then(res => {
            this.$message.success(res.msg)
            this.guideArticleListH5()

          })
        })
        .catch(() => { });

    },
    preview(content) {
      this.content = content
      this.dialogVisible = true
    },
    // 是否展示new
    guideIsNewH5(item, type) {
      let datas = {
        id: item.id,
        isNew: item.is_new ? 1 : 0,
        type
      }
      this.$api.siteConfiguration.guideIsNewH5(datas)
    }
  }
}
</script>
<style lang='scss' scoped>
@import "../../../../css/quillbubble.css";
@import "../../../../css/quillcore.css";
@import "../../../../css/quillsnow.css";


.search {
  margin: 0 0 20px 0;
  height: 40px;
  text-align: right;
}

.table {
  .item {
    &:nth-child(1) {
      border-top: 1px solid #ccc;
    }

    i {
      margin-left: 20px;
      font-size: 25px;
      cursor: pointer;

      &:hover {
        color: #b4272d;
      }

    }

    .head,
    .content {
      display: flex;
      background-color: #EDEFF4;
      border: 1px solid #ccc;
      border-top: 0;



      .items {
        text-align: center;
        padding: 10px 0;
        border-right: 1px solid #ccc;

        &:nth-last-child(1) {
          border: 0;
        }
      }

      .sort {
        flex: 1;
      }

      .categoryName {
        flex: 8;
      }

      .operation {
        flex: 1;
      }
    }

    .content {
      background-color: #fff;
      border-top: 0 !important;
    }

    ol {
      border: 1px solid #ccc;
      border-top: 0;
      text-align: center;
    }

    ul {
      border: 1px solid #ccc;
      border-top: 0;
      padding: 0;
    }

    li {
      border-right: 1px solid #ccc;
      padding: 10px 0;
      display: block;

      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex3 {
      flex: 3;
    }

    .flex5 {
      flex: 5;
    }

    .flex15 {
      flex: 1;
    }

    .flex {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

}

/deep/.preview {
  h1 {
    font-size: 32px;
    font-weight: bold;
  }

  h2 {
    font-size: 24px;
    font-weight: bold;
  }

  h3 {
    font-size: 18.72px;
    font-weight: bold;
  }

  h4 {
    font-size: 16px;
    font-weight: bold;
  }

  h5 {
    font-size: 13.28px;
    font-weight: bold;
  }

  h6 {
    font-size: 12px;
    font-weight: bold;
  }

  img {
    max-width: 100% !important;
  }


  p {
    font-size: 16px;
    color: #000
  }

}
</style>